import React, { useEffect, useState, Fragment } from 'react';
interface CountdownProps {
  className?: string;
  light?: boolean;
}
export function Countdown({
  className = '',
  light = false
}: CountdownProps) {
  const [seconds, setSeconds] = useState(84715);
  useEffect(() => {
    const timer = window.setInterval(() => setSeconds(value => Math.max(0, value - 1)), 1000);
    return () => window.clearInterval(timer);
  }, []);
  const units = [['hs', Math.floor(seconds / 3600)], ['min', Math.floor(seconds % 3600 / 60)], ['seg', seconds % 60]];
  return <div className={`inline-flex items-start gap-2 rounded-xl border px-4 py-2 font-mono font-black ${light ? 'border-white/30 bg-white text-forest-dark' : 'border-red-200 bg-red-50 text-red-700'} ${className}`} data-id="element-284">
      {units.map(([label, value], index) => <Fragment key={label} data-id="element-285">
          {index > 0 && <span className="pt-1 text-xl opacity-40" data-id="element-286">:</span>}
          <span className="flex min-w-[36px] flex-col items-center leading-none" data-id="element-287">
            <b className="text-xl" data-id="element-288">{String(value).padStart(2, '0')}</b>
            <small className="mt-1 font-sans text-[9px] font-bold uppercase tracking-wider opacity-70" data-id="element-289">
              {label}
            </small>
          </span>
        </Fragment>)}
    </div>;
}